import {Language, Platform} from "@variocube/app-api";
import {AbstractApp} from "@variocube/app-common";
import * as React from "react";
import {Component} from "react";
import icon from "./icon.svg";
import {render} from "react-dom";

export default class MidiSynthApp extends AbstractApp {

    constructor(platform:Platform) {
        super(platform, icon, '#143259', [Language.EN]);
        this.name = "Midisynth";
        this.description = "Play the Midisynth synthesizer";
        this.updateLauncherItems();
    }

    render(root: Element) {
        render(<HomeScreen/>, root);
    }

}

class HomeScreen extends Component {
    render() {
        return (
            <div>
                <iframe src="https://webaudiodemos.appspot.com/midi-synth/index.html" style={{ width:"100%", height:"100%"}} />
            </div>
        )
    }
}

